import React from 'react'
import { HStack, VStack, AspectRatio, Text, Image, Box } from '@chakra-ui/react';
import { Link } from 'react-router-dom'

export default function ProductCard({ product }) {
    console.log(product.product_variants);
    return (
        <a href={`/product/${product.product_variants.slug}`}>
            <VStack spacing='1' alignItems='start'>
                {/* <AspectRatio ratio={1} w='100%'>
                    <img src={product.product_variants.image1} alt='product' style={{ maxWidth: '300px', height: '300px' }} />
                </AspectRatio> */}
                {/* <AspectRatio ratio={11.6 / 14} w='100%' h='auto'>
                    <img src={`${product.product_variants.image1}?width=400`} alt='product' />
                </AspectRatio> */}
                {/* <img
                    src={`${product.product_variants.image1}?width=330`}
                    alt='product'
                    style={{
                        maxWidth: '330px',
                        height: 'auto', 
                        objectFit: 'cover',
                        height: '100%',
                        objectPosition: 'center'
                    }}
                /> */}

                <Box
                    display={{ base: 'block', md: 'none' }}
                    aspectRatio={1}
                    minWidth='100%'
                    backgroundPosition="center center"
                    backgroundRepeat="no-repeat"
                    backgroundSize="cover"
                    backgroundImage={`url(${product.product_variants.image1}?width=1330)`}
                />

                <Box
                    display={{ base: 'none', md: 'block' }}
                    aspectRatio={2 / 3}
                    minWidth='330px'
                    backgroundPosition="center center"
                    backgroundRepeat="no-repeat"
                    backgroundSize="contain"
                    backgroundImage={`url(${product.product_variants.image1}?width=1330)`}
                />

                <Text w='100%' className='twoLineText' as='h1' fontSize='md'>
                    {product.products.name}
                </Text>
                <HStack justifyContent='start' w='100%'>
                    <HStack spacing='0'>
                        <Image src='/rupee_light.png' w='6px' me='0.5' />
                        <Text style={{ textDecoration: 'line-through' }} fontSize='sm'>
                            {product.product_variants.mrp}
                        </Text>
                    </HStack>

                    <HStack spacing='0'>
                        <Image src='/rupee.png' w='10px' me='0.5' />
                        <Text as='h1' className='customfont' fontSize='md'>
                            {product.product_variants.selling_price}
                        </Text>
                    </HStack>

                    <Text
                        color='#ff5c5c'
                        fontSize={[12, 14, 18, 18]}>
                        ({Math.round(((product.product_variants.mrp - product.product_variants.selling_price) / product.product_variants.mrp) * 100)}% off)
                    </Text>
                </HStack>
            </VStack>
        </a>
    )
}
